import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Select,
  Tag,
  Divider,
  Image,
  Form,
  Dropdown,
  Modal,
} from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
// import { ImageViewer } from "react-image-viewer-dv";
import { professionalAction } from "../../../_actions";
import { ImageView } from "../../image/imageView";
import { LanguageContext } from "../../../context/LanguageContext";
import { ViewGunaDetails } from "../../viewGunaDetails/viewGunaDetails";
import { connect } from "react-redux";
const { Option } = Select;

const styles = {
  pageContainer: {
    padding: "16px 0",
    width: "100%",
  },
  headerCard: {
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
  },
  filterSection: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-start",
    width: "100%",
  },
  formItem: {
    flex: "1 1 280px",
    minWidth: "280px",
    marginBottom: 0,
  },
  selectInput: {
    width: "100%",
  },
  buttonGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
    alignItems: "flex-end",
  },
  actionButton: {
    minWidth: "120px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  viewTypeSection: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    alignItems: "center",
    padding: "12px",
    background: "#f5f5f5",
    borderRadius: "8px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    marginBottom: "16px",
  },
  totalCount: {
    padding: "4px 12px",
    background: "#fff",
    borderRadius: "4px",
    border: "1px solid #d9d9d9",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  tableContainer: {
    width: "100%",
    overflowX: "auto",
    background: "#fff",
    borderRadius: "8px",
    border: "1px solid #f0f0f0",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  },
};

// Add styles at the top of the file
class TablePreventiveReport extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      searchedColumn: "",
      total: 0,
      pageSize: 10,
      currentPage: 0,
      criminalList1: [],
      data: [],
      orderDirection: "",
      search: false,
      tableLoading: false,
      isLoading: false,
      crimeTitle: [],
      selectedHeadings: [],
      isFilterActive: false,
      photoFilterStatus: "",
      filterData: [],
      pagination: {
        current: 1,
        pageSize: 10,
      },
      imageOpen: false,
      selectedImage: null,
      showGunaDetails: false,
      gunaLoading: false,
    };
  }
  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };
  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };

  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  componentDidUpdate(prevProps) {
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
  }

  openImageModal = (img, name, id) => {
    this.setState({ imageOpen: true, selectedImage: img, name: name, id: id });
  };

  closeImageModal = () => {
    this.setState({ imageOpen: false, selectedImage: null, name: null });
  };

  sortTableData = (data, sorter) => {
    if (!sorter?.order || !data?.length) {
      return data;
    }

    const compareFn = sorter.column?.sorter?.compare;
    const field = sorter.field || sorter.columnKey;

    return [...data].sort((a, b) => {
      let result = 0;
      if (compareFn) {
        result = compareFn(a, b);
      } else if (field) {
        let x = a[field] ?? "";
        let y = b[field] ?? "";
        const isNumeric = !isNaN(x) && !isNaN(y) && x !== "" && y !== "";

        if (isNumeric) {
          result = Number(x) - Number(y);
        } else {
          result = x
            .toString()
            .toLowerCase()
            .localeCompare(y.toString().toLowerCase());
        }
      }
      return sorter.order === "ascend" ? result : -result;
    });
  };

  handleTableChange = (pagination, filters, sorter, extra) => {
    if (filters.photo) {
      this.setState({ photoFilterStatus: filters.photo[0] }); // "has" or "none"
    } else {
      this.setState({ photoFilterStatus: undefined });
    }
    this.setState({
      pagination: {
        ...this.state.pagination,
        ...pagination, // updates current and pageSize from AntD
      },
    });

    if (!this.props.onTableSortChange || extra?.action !== "sort") {
      return;
    }

    const sourceData = this.props.reportList1?.length
      ? [...this.props.reportList1]
      : this.props.data
        ? [...this.props.data]
        : [];

    if (sorter?.order) {
      const sortedData = this.sortTableData(sourceData, sorter);
      this.props.onTableSortChange(sortedData, {
        field: sorter.field || sorter.columnKey,
        order: sorter.order,
      });
      return;
    }

    const restoredData = this.props.reportList1?.length
      ? [...this.props.reportList1]
      : sourceData;
    this.props.onTableSortChange(restoredData, null);
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(e) => {
              this.handleSearch(selectedKeys, confirm, dataIndex);
              if (
                this.props &&
                (this.props?.report === true ||
                  this.props?.ongoing === true ||
                  this.props?.new === true ||
                  this.props?.completed === true)
              ) {
                this.searchDataReport(this.state.searchText);
              } else {
                this.searchdata(selectedKeys[0]);
              }
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              this.handleReset(clearFilters);
              this.clear();
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    // onFilter: (value, record) =>
    //   record[dataIndex]
    //     ? record[dataIndex]
    //         .toString()
    //         .toLowerCase()
    //         .includes(value.toLowerCase())
    //     : "",
    // onFilterDropdownVisibleChange: (visible) => {
    //   if (visible) {
    //     setTimeout(() => this.searchInput.select(), 100);
    //   }
    // },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = async (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys,
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleViewForm = (data) => {
    this.props.onViewAccusedForm(data);
  };

  clear = () => {
    if (this.props.headings.length > 0) {
      this.props.clearOnlySearch();
    } else {
      this.props.clearData();
    }
    this.setState({ criminalList1: [], searchText: "" });
  };
  render() {
    console.log("this.props report", this.props);
    console.log("loading ", this.props.loading);
    const { professionals } = this.props;
    const { t } = this.context;
    const { pagination, photoFilterStatus } = this.state;

    let tempColumns = [];
    let columnsOb = [
      {
        title: t("sr.no"),
        key: "srNo",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.srNo}
          </Space>
        ),
      },
      {
        title: "पोलिस स्टेशन(कारवाई करणारे)",
        key: "action_taken_police_station",
        dataIndex: "action_taken_police_station",
        sorter: {
          compare: (a, b) =>
            a.action_taken_police_station - b.action_taken_police_station,
        },
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        // ...this.getColumnSearchProps("name"),
        render: (text, record) => (
          <Space
            title={record.basic_id}
            size="middle"
            style={{ maxWidth: 300 }}
          >
            {record.action_taken_police_station}
          </Space>
        ),
      },
      {
        title: t("preventive_action"),
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        key: "preventiveActionName",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.preventiveActionName}
          </Space>
        ),
      },
      {
        title: t("period_from"),
        key: "date_from",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {moment(record.date_from).format("DD/MM/YYYY")}
          </Space>
        ),
      },
      {
        title: t("period_to"),
        key: "date_to",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {moment(record.date_to).format("DD/MM/YYYY")}
          </Space>
        ),
      },
      {
        title: t("name_of_the_accused"),
        key: "name",
        dataIndex: "name",
        // ...this.getColumnSearchProps("name"),
        render: (text, record) => (
          <Space size="middle" title={record.id} style={{ maxWidth: 300 }}>
            {record.name}
          </Space>
        ),
      },
      {
        title: t("age"),
        key: "age",
        sorter: {
          compare: (a, b) => a.age - b.age,
        },
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.age}
          </Space>
        ),
      },
      {
        title: t("accused_police_station"),
        key: "districtName",
        sorter: {
          compare: (a, b) => a.districtName - b.districtName,
        },
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.districtName}
          </Space>
        ),
      },
      {
        title: t("total_crimes"),
        key: "totalCrimeCount",
        sorter: {
          compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
        },
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              shape="circle"
              size="small"
              style={{
                width: 36,
                height: 36,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              }}
              onClick={() => {
                this.onGunaForm(record.id);
              }}
            >
              {record.totalCrimeCount}
            </Button>
          </div>
        ),
      },

      {
        title: t("photo"),
        key: "photo",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.photo ? (
              // <ImageViewer>
              <img
                style={{ width: 50, height: 50, cursor: "pointer" }}
                src={`https://pcimageupload.s3.ap-south-1.amazonaws.com/${
                  record.photo // Get the first non-empty image
                }`}
                onClick={() =>
                  this.openImageModal(record.photo, record.name, record.id)
                }
              />
            ) : (
              // </ImageViewer>
              "नाही"
            )}
          </Space>
        ),
      },
      {
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleViewForm(record.id);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      },
    ];

    let Columnviolators = [
      {
        title: t("sr.no"),
        key: "srNo",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.srNo}
          </Space>
        ),
      },
      {
        title: "पोलिस स्टेशन(कारवाई करणारे)",
        key: "action_taken_police_station",
        dataIndex: "action_taken_police_station",
        sorter: {
          compare: (a, b) =>
            a.action_taken_police_station - b.action_taken_police_station,
        },
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#ffcc80",
            color: "#000",
          },
        }),
        // ...this.getColumnSearchProps("name"),
        render: (text, record) => (
          <Space
            title={record.basic_id}
            size="middle"
            style={{ maxWidth: 300 }}
          >
            {record.action_taken_police_station}
          </Space>
        ),
      },
      {
        title: t("preventive_action"),
        key: "preventiveActionName",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.preventive_action_name}
          </Space>
        ),
      },
      {
        title: t("period_from"),
        key: "date_from",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {moment(record.date_from).format("DD/MM/YYYY")}
          </Space>
        ),
      },
      {
        title: t("period_to"),
        key: "date_to",
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {moment(record.date_to).format("DD/MM/YYYY")}
          </Space>
        ),
      },
      {
        title: t("name"),
        key: "name",
        dataIndex: "name",
        // ...this.getColumnSearchProps("name"),
        render: (text, record) => (
          <Space
            title={record.basic_id}
            size="middle"
            style={{ maxWidth: 300 }}
          >
            {record.name}
          </Space>
        ),
      },

      {
        title: t("accused_police_station"),
        key: "accused_police_station",
        sorter: {
          compare: (a, b) =>
            a.accused_police_station - b.accused_police_station,
        },
        render: (text, record) => (
          <Space size="middle" style={{ maxWidth: 300 }}>
            {record.districtName}
          </Space>
        ),
      },

      {
        title: t("crime_registration_date"),
        key: "name",
        dataIndex: "name",
        render: (text, record) => (
          <>
            <p>
              {" "}
              <b>{record?.registernumber}</b>-
              {moment(record?.gunha_dateTime).format("DD/MM/YYYY")}/
            </p>
            <p>{record?.guna_districtName}</p>
          </>
        ),
      },
      // {
      //   title: t("crime_register_number"),
      //   key: "registernumber",
      //   dataIndex: "registernumber",
      //   render: (text, record) => (
      //     <>
      //       <p>{record?.registernumber}</p>
      //     </>
      //   ),
      // },
      {
        title: "कायदा कलम",
        key: "name",
        dataIndex: "name",
        render: (text, record) => {
          const kkInfoArray = Array.isArray(record.kk_info)
            ? record.kk_info
            : [];

          if (kkInfoArray.length === 0) return null;

          // Group kalam → unique rules
          const grouped = kkInfoArray.reduce((acc, item) => {
            const name = item?.rulesName || "-"; // rule name
            const kalma = item?.kalam || "-"; // kalam

            if (!acc[name]) {
              acc[name] = [kalma];
            } else if (!acc[name].includes(kalma)) {
              acc[name].push(kalma);
            }
            return acc;
          }, {});

          return (
            <Space direction="vertical" size="small" style={{ maxWidth: 300 }}>
              {Object.entries(grouped).map(([ruleName, kalams], idx) => (
                <p key={idx}>
                  {`${ruleName}${
                    kalams.length ? " , " + kalams.join(", ") : ""
                  }`}
                </p>
              ))}
            </Space>
          );
        },
      },
      {
        title: "भरलेले दिनांक",
        key: "name",
        dataIndex: "name",
        render: (text, record) => (
          <>
            {record.notification_date ? (
              <>{moment(record?.notification_date).format("DD/MM/YYYY")}</>
            ) : (
              ""
            )}
          </>
        ),
      },
      {
        title: "कारण",
        key: "name",
        dataIndex: "name",
        render: (text, record) => (
          <>{record?.reason ? <>{record?.reason}</> : ""}</>
        ),
      },
      {
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                this.handleViewForm(record.basic_id);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      },
    ];
    let tebleData = this.state.searchText
      ? this.state.criminalList1 &&
        this.state.criminalList1.length > 0 &&
        this.state.criminalList1.map((item, index) => {
          return {
            ...item,
            srNo: index + 1,
          };
        })
      : this.props.data &&
        this.props.data.map((item, index) => {
          return {
            ...item,
            srNo: index + 1,
          };
        });
    const filteredPhotoCount =
      photoFilterStatus === "none"
        ? 0
        : tebleData.filter((record) => {
            return record.photo;
          }).length;

    console.log("props", this.props.data);
    console.log("violators_list", this.props.violators_list);

    return (
      <>
        {this.props.showList === "यादी" && (
          <>
            <div>
              <div style={styles.viewTypeSection}>
                <div className="stats-card stats-accused">
                  <span className="stats-text">
                    {t("total_accused_count")}: {tebleData.length}
                  </span>
                </div>
                <div className="stats-card stats-photo">
                  <span className="stats-text">
                    {t("total_photo_count")}:{" "}
                    {filteredPhotoCount ? filteredPhotoCount : "0"}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
        {this.props.violators_list ? (
          <Table
            bordered
            loading={this.props.loading}
            key={tebleData}
            columns={Columnviolators}
            dataSource={tebleData}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
            }}
            onChange={this.handleTableChange}
            rowClassName={() => "govt-table-row"}
          />
        ) : (
          <Table
            loading={this.props.loading}
            key={tebleData}
            columns={columnsOb}
            dataSource={tebleData}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
            }}
            onChange={this.handleTableChange}
          />
        )}

        {this.state.imageOpen && (
          <ImageView
            imageOpen={this.state.imageOpen}
            imageUrl={`${process.env.REACT_APP_PROFILE_IMAGE_BUCKET_URL}${this.state.selectedImage}`}
            name={this.state.name}
            onClose={this.closeImageModal}
            id={this.state.id}
          />
        )}
        <Modal
          title={t("crime_information")}
          top
          visible={this.state.showGunaDetails}
          onOk={this.closeGunaViewModel}
          onCancel={this.closeGunaViewModel}
          width={95 + "%"}
        >
          <ViewGunaDetails
            pc_crimetitles={professionals?.pc_crimetitles}
            dataStates={
              Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
              professionals?.criminalViewList?.gunhaInfor.length > 0
                ? professionals?.criminalViewList?.gunhaInfor
                : []
            }
            address={
              (Array.isArray(professionals?.criminalViewList?.basicInfo) &&
                professionals?.criminalViewList?.basicInfo?.[0]?.address) ||
              ""
            }
            name={
              (Array.isArray(professionals?.criminalViewList?.basicInfo) &&
                professionals?.criminalViewList?.basicInfo?.[0]?.name) ||
              ""
            }
            loading={this.state.gunaLoading}
            user_details={this.props?.user}
            masterId={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].id
                : ""
            }
            closeGunaViewModel={this.closeGunaViewModel}
          ></ViewGunaDetails>
        </Modal>
      </>
    );
  }
}
function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedTablePreventiveReport = connect(mapStateToProps)(
  TablePreventiveReport,
);
export { connectedTablePreventiveReport as TablePreventiveReport };
